import type { Observable } from 'rxjs';
import type { CollectionStateStatuses } from '@common/adapters/collections';
import type { SiteListEntity } from '@common/types/site.type';
import type { SitesCollectionState } from './sites.reducer';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { mergeMap, of } from 'rxjs';

import SitesActions from './sites.actions';
import * as SitesSelectors from './sites.selectors';

@Injectable()
export class SitesCollectionFacade {
    private readonly store = inject<Store<SitesCollectionState>>(Store);

    public readonly sitesState$: Observable<SitesCollectionState> = this.store.select(SitesSelectors.selectSitesState);
    public readonly sitesStatuses$: Observable<CollectionStateStatuses> = this.store.select(
        SitesSelectors.selectSitesStatuses
    );

    public loadSitesCollection(): void {
        this.store.dispatch(SitesActions.loadCollectionRequest());
    }

    public get sites$(): Observable<SiteListEntity[]> {
        return this.store.select(SitesSelectors.selectSites).pipe(
            mergeMap((sites) => {
                if (sites === null) {
                    this.loadSitesCollection();
                    return of([]);
                }

                return of(sites);
            })
        );
    }
}
